import {
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { AiOutlineMenu } from "react-icons/ai";
import { HashLink } from "react-router-hash-link";
import { AppContext } from "../../utils";
import logo from "./assets/logo.png";
import { FaDiscord } from "react-icons/fa";
import { BsTwitter } from "react-icons/bs";
function CustomDrawer({ openLogout, setopenLogout }) {
  const [anchorEl, setanchorEl] = useState(null);
  const { account, connect, disconnect } = useContext(AppContext);

  // Drawer top
  const [state, setState] = useState({
    top: true,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchorEl, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchorEl]: open });
  };
  const connectHanle = async () => {
    try {
      await connect();
    } catch (error) {
      console.log(error);
    }
  };

  const list = (anchorEl) => (
    <Box
      sx={{
        width: anchorEl === "top" || anchorEl === "bottom" ? "auto" : 250,
        background:
          "linear-gradient(180deg, #101440 3.4%, #511D66 33.94%, #CF1B52 89.2%)",
        // backgroundSize: "contain",
      }}
      minHeight="120%"
      height="100%"
      role="presentation"
      onClick={toggleDrawer(anchorEl, false)}
      onKeyDown={toggleDrawer(anchorEl, false)}
    >
      <List>
        {[
          <Box
            display="flex"
            alignItem="centre"
            justifyContent="center"
            smooth
            to="/#home"
            py={2}
          >
            <img
              src={logo}
              alt=""
              style={{
                borderRadius: "50%",
              }}
            />
          </Box>,
          <Box
            fontFamily="'Baloo Bhai 2', cursive"
            smooth
            to="/#home"
            display="flex"
            alignItem="centre"
            justifyContent="center"
            style={{ textDecoration: "none", color: "#F3ADB4" }}
          >
            THE SOULMAPES
          </Box>,
          <HashLink style={{ textDecoration: "none" }} smooth to="/#aboutus">
            <Box
              smooth
              fontFamily="'Baloo Bhai 2', cursive"
              to="/#mission"
              display="flex"
              alignItem="centre"
              justifyContent="center"
              style={{ textDecoration: "none", color: "white" }}
            >
              ABOUT US
            </Box>
          </HashLink>,
          <HashLink style={{ textDecoration: "none" }} smooth to="/#freq">
            <Box
              fontFamily="'Baloo Bhai 2', cursive"
              smooth
              to="/#roadmap"
              display="flex"
              alignItem="centre"
              justifyContent="center"
              style={{ textDecoration: "none", color: "white" }}
            >
              ROADMAP
            </Box>
          </HashLink>,
          <HashLink style={{ textDecoration: "none" }} smooth to="/#freq">
            <Box
              smooth
              fontFamily="'Baloo Bhai 2', cursive"
              to="/#team"
              display="flex"
              alignItem="centre"
              justifyContent="center"
              style={{ textDecoration: "none", color: "white" }}
            >
              THE TEAM
            </Box>
          </HashLink>,
          <HashLink style={{ textDecoration: "none" }} smooth to="/#freq">
            <Box
              smooth
              fontFamily="'Baloo Bhai 2', cursive"
              to="/#freq"
              display="flex"
              alignItem="centre"
              justifyContent="center"
              style={{ textDecoration: "none", color: "white" }}
            >
              FAQ's
            </Box>
          </HashLink>,
        ].map((text, index) => (
          <ListItem
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            button
            key={text}
          >
            <Box
              fontFamily="Josefin Sans"
              fontSize="20px"
              width="100%"
              sx={{ cursor: "pointer" }}
              color="white"
            >
              {text}
            </Box>

            {/* <Divider
              sx={{
                width: "280px",
                border: " white solid 1px",
              }}
            /> */}
          </ListItem>
        ))}

        <ListItem
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          button
        >
          <a
            style={{ textDecoration: "none", color: "white" }}
            href=" https://discord.com/invite/soulmapes"
            target="_blank"
          >
            <Box
              width="40px"
              height="40px"
              sx={{
                "&:hover": {
                  background: "#101440",
                },
                backgroundColor: "#CF1B52",
                borderRadius: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FaDiscord
                style={{
                  fontSize: "25px",
                }}
              />
            </Box>
          </a>
          <a
            style={{
              textDecoration: "none",
              color: "white",
              marginTop: "10px",
            }}
            href="  https://twitter.com/soulmapes"
            target="_blank"
          >
            <Box
              width="40px"
              height="40px"
              sx={{
                "&:hover": {
                  background: "#101440",
                },
                backgroundColor: "#CF1B52",
                borderRadius: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <BsTwitter
                style={{
                  fontSize: "25px",
                }}
              />
            </Box>
          </a>
        </ListItem>

        <ListItem
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {account ? (
            <>
              {" "}
              <Button
                onClick={() => {
                  setopenLogout(true);
                }}
                sx={{
                  color: "#F3ADB4",
                  border: "2px solid #F3ADB4",
                  borderRadius: "50px",
                  width: "125px",
                  height: "36px",
                  fontFamily: "'Baloo Bhai 2', cursive",
                  fontWeight: "600",
                  paddding: "10px",
                }}
              >
                {account.slice(0, 10) + "....."}
              </Button>{" "}
            </>
          ) : (
            <>
              {" "}
              <Button
                onClick={connectHanle}
                sx={{
                  color: "#F3ADB4",
                  border: "2px solid #F3ADB4",
                  borderRadius: "50px",
                  width: "125px",
                  height: "36px",
                  fontFamily: "'Baloo Bhai 2', cursive",
                  fontWeight: "600",
                  paddding: "10px",
                }}
              >
                connect
              </Button>{" "}
            </>
          )}
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      <IconButton onClick={toggleDrawer(anchorEl, true)}>
        <AiOutlineMenu color="white" style={{ fontSize: "36px" }} />
      </IconButton>

      <Drawer
        className="drawer"
        anchorEl={anchorEl}
        open={state[anchorEl]}
        onClose={toggleDrawer(anchorEl, false)}
      >
        {list(anchorEl)}
      </Drawer>
    </>
  );
}

export default CustomDrawer;
